import React from 'react'
import styled from 'styled-components'
import Dropzone from 'react-dropzone'

const Container = styled.div`
    height: 100%;
    /* width: 20px; */
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 0 1.4rem; */
    cursor: pointer;

    .__dropComponent {
        height: 85%;
        width: 85%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`
const Icon = styled.i`
    font-family: Font Awesome 5 Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    /* line-height: 40px; */
    color: #37a3ef;
    width: 110px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    &:hover {
        opacity: 0.6;
    }

    span {
        font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        display: block;
        padding: 0 0.4rem;
        white-space: nowrap;
        color: #37a3ef;
    }
`

interface Props {
    upload: Function
    history: Function
    remove?: Function
    isModel?: boolean
    model?: String
}

export default function DroIcon({ upload, history, remove, isModel, model }: Props) {
    return (
        <Container>
            <Dropzone
                className="__dropComponent"
                activeClassName="active"
                key={model || 'default'}
                activeStyle={{}}
                onDrop={files => upload(history, files[0], isModel, model)}
            >
                {({ getRootProps, getInputProps }) => {
                    return (
                        <span {...getRootProps()}>
                            <input {...getInputProps()} />
                            <Icon className="fa fa-upload">
                                <span>Upload Data</span>
                            </Icon>
                        </span>
                    )
                }}
            </Dropzone>
        </Container>
    )
}
